var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClusteredBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M1 7H20C20.5523 7 21 7.44772 21 8V12C21 12.5523 20.5523 13 20 13H1V7Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M1 13H32C32.5523 13 33 13.4477 33 14V18C33 18.5523 32.5523 19 32 19H1V13Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M1 23H28C28.5523 23 29 23.4477 29 24V28C29 28.5523 28.5523 29 28 29H1V23Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M1 29H20C20.5523 29 21 29.4477 21 30V34C21 34.5523 20.5523 35 20 35H1V29Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    d: "M1 1V41H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusteredBar);
export default __webpack_public_path__ + "static/media/clustered-bar.e193b81c651aaf0be181b0634cc585d4.svg";
export { ForwardRef as ReactComponent };